import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _styled from "@emotion/styled-base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import AKInlineDialog from '@atlaskit/inline-dialog';
import React, { PureComponent } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A wrapper over Atlaskit's Inline dialog component that
 * functions like a tooltip, i.e. is invoked on hover
 * https://atlaskit.atlassian.com/packages/core/inline-dialog
 */

export const RichTooltipContainer = _styled("span", {
  target: "e1l6eq9s0",
  label: "RichTooltipContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1c3h18e",
  styles: "flex:1 0 auto;"
} : {
  name: "1c3h18e",
  styles: "flex:1 0 auto;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const RICH_TOOLTIP_CLASS = 'rich_tooltip__container';
export default class RichTooltip extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "showTimerId", void 0);
    _defineProperty(this, "hideTimerId", void 0);
    _defineProperty(this, "isFocused", void 0);
    _defineProperty(this, "state", {
      isOpen: false
    });
    _defineProperty(this, "handleFocusChange", e => {
      const isTooltipChild = target => !(target instanceof HTMLElement) || !target.closest(".".concat(RICH_TOOLTIP_CLASS));
      if (isTooltipChild(e.target)) {
        this.isFocused = false;
        this.setState({
          isOpen: false
        });
      }
    });
    _defineProperty(this, "handleMouseEnter", () => {
      clearTimeout(this.hideTimerId);
      this.showTimerId = setTimeout(() => {
        this.setState({
          isOpen: true
        });
      }, this.props.delay);
    });
    _defineProperty(this, "handleMouseLeave", () => {
      if (this.isFocused) return;
      clearTimeout(this.showTimerId);

      // Add a delay, allowing some time for the cursor to
      // hop onto the tooltip area without close being triggered
      this.hideTimerId = setTimeout(() => {
        this.setState({
          isOpen: false
        });
      }, 150);
    });
    _defineProperty(this, "handleFocus", () => {
      this.isFocused = true;
      this.setState({
        isOpen: true
      });
    });
    _defineProperty(this, "onClose", () => {
      this.isFocused = false;
      this.setState({
        isOpen: false
      });
    });
    _defineProperty(this, "handleContentBlur", () => {
      if (!this.props.disableBlurEvent) {
        this.onClose();
      }
    });
  }
  componentDidMount() {
    document.addEventListener('focus', this.handleFocusChange, true);
  }
  componentWillUnmount() {
    document.removeEventListener('focus', this.handleFocusChange, true);
  }
  render() {
    const {
      isOpen
    } = this.state;
    const {
      children,
      content
    } = this.props;
    return /*#__PURE__*/_jsx(RichTooltipContainer, {
      className: RICH_TOOLTIP_CLASS,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      children: /*#__PURE__*/_jsx(AKInlineDialog, {
        content: content,
        isOpen: isOpen,
        onClose: this.onClose,
        onContentBlur: this.handleContentBlur,
        testId: "inline-dialog",
        children: /*#__PURE__*/_jsx("span", {
          tabIndex: 0,
          onFocus: this.handleFocus,
          role: "tooltip",
          children: children
        })
      })
    });
  }
}
_defineProperty(RichTooltip, "defaultProps", {
  delay: 200
});